export default [
  {
    path: '/admin/finance',
    name: 'Finance',
    component: () => import('@/views/Admin/Finance/Index.vue'),
    meta: {
      pageTitle: 'Finans',
      breadcrumb: [
        { text: 'Finans', active: true },
      ],
      resource: 'reports.list',
      action: 'read',
    },
  },
]
